module.exports = __webpack_public_path__ + "img/banner_jia.e9fced00.png";